import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** 増減履歴処理 */
enum IncDecHistoryProcessing {
  faAcquisition = '1',
  faRetire = '2',
  faEstimateChange = '3',
  faImpairmentLossEntry = '4',
  faInfoChange = '5',
  faReductionEntry = '6',
  faDepAdjEntry = '8',
  faUnusedPeriodSetting = '9',
  faDivision = '10',
  faSales = '11',
  faTransfer = '12',
  faAllocBasisSetting = '13',
  faAddDepSetting = '14',
  faSegmentChange = '15',
  faSubCategoryChange = '16',
  faDeclarationItemChange = '17',
  faImpairmentReversal = '18',
  laEntry = '19',
  leaseLiabilityEstimateChange = '21',
}

const nameConfig = {
  faAcquisition: new Map([[Locale.ja, '固定資産取得']]),
  faRetire: new Map([[Locale.ja, '固定資産除却']]),
  faEstimateChange: new Map([[Locale.ja, '固定資産見積変更']]),
  faImpairmentLossEntry: new Map([[Locale.ja, '固定資産減損損失計上']]),
  faInfoChange: new Map([[Locale.ja, '固定資産情報変更']]),
  faReductionEntry: new Map([[Locale.ja, '固定資産圧縮記帳']]),
  faDepAdjEntry: new Map([[Locale.ja, '固定資産任意償却費計上']]),
  faUnusedPeriodSetting: new Map([[Locale.ja, '固定資産遊休設定']]),
  faDivision: new Map([[Locale.ja, '固定資産分割']]),
  faSales: new Map([[Locale.ja, '固定資産売却']]),
  faTransfer: new Map([[Locale.ja, '固定資産移動']]),
  faAllocBasisSetting: new Map([[Locale.ja, '固定資産配賦基準設定']]),
  faAddDepSetting: new Map([[Locale.ja, '固定資産増加償却設定']]),
  faSegmentChange: new Map([[Locale.ja, '固定資産セグメント変更']]),
  faSubCategoryChange: new Map([[Locale.ja, '固定資産分類変更']]),
  faDeclarationItemChange: new Map([[Locale.ja, '固定資産申告項目変更']]),
  faImpairmentReversal: new Map([[Locale.ja, '固定資産減損額戻入']]),
  laEntry: new Map([[Locale.ja, 'リース登録']]),
  leaseLiabilityEstimateChange: new Map([[Locale.ja, 'リース見積変更']]),
};

const toEnum = rawValueToEnum(IncDecHistoryProcessing, IncDecHistoryProcessing.faAcquisition);
const toDisplay = enumToName(IncDecHistoryProcessing, nameConfig);
const toDisplayWithPrefix = enumToName(IncDecHistoryProcessing, nameConfig, {
  prefix: true,
});

export const incDecHistoryProcessing = {
  enum: IncDecHistoryProcessing,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { IncDecHistoryProcessing };
